var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Check(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 3C14.3855 3.00254 16.6739 3.95121 18.3613 5.63867C20.0488 7.32613 20.9975 9.61455 21 12.001C20.9998 13.7806 20.4721 15.5203 19.4834 17C18.4945 18.4799 17.0887 19.6332 15.4443 20.3145C13.7998 20.9956 11.99 21.1744 10.2441 20.8271C8.49832 20.4799 6.89441 19.6229 5.63574 18.3643C4.37708 17.1056 3.52012 15.5017 3.17285 13.7559C2.82558 12.01 3.00436 10.2002 3.68555 8.55566C4.36675 6.91127 5.52005 5.50547 7 4.5166C8.47973 3.52792 10.2194 3.00019 11.999 3Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5862 9.49535L10.9056 15.3315L8.51815 12.7078",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Check);
export default __webpack_public_path__ + "static/media/24_check.f7f8abc3522ccb07c8e1748f33107478.svg";
export { ForwardRef as ReactComponent };